import { useState, useEffect } from 'react';
import { t, useLocale } from '../i18n';

type Theme = 'professional' | 'poker' | 'dark';

type Props = {
    onThemeChange?: (theme: Theme) => void;
};

export default function ThemeToggle({ onThemeChange }: Readonly<Props>) {
    useLocale(); // rerender on locale change
    const [theme, setTheme] = useState<Theme>(() => {
        const saved = localStorage.getItem('poker-theme');
        return (saved as Theme) || 'professional';
    });

    useEffect(() => {
        localStorage.setItem('poker-theme', theme);
        document.body.className = `theme-${theme}`;
        onThemeChange?.(theme);
    }, [theme, onThemeChange]);

    return (
        <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-1">
            <button
                onClick={() => setTheme('professional')}
                className={[
                    'px-3 py-1.5 rounded-md text-xs font-medium transition-all',
                    theme === 'professional'
                        ? 'bg-white shadow text-slate-900'
                        : 'text-slate-600 hover:text-slate-900'
                ].join(' ')}
                title={t('theme.professional.title')}
            >
                💼 {t('theme.professional.label')}
            </button>
            <button
                onClick={() => setTheme('poker')}
                className={[
                    'px-3 py-1.5 rounded-md text-xs font-medium transition-all',
                    theme === 'poker'
                        ? 'bg-white shadow text-slate-900'
                        : 'text-slate-600 hover:text-slate-900'
                ].join(' ')}
                title={t('theme.poker.title')}
            >
                🎰 {t('theme.poker.label')}
            </button>
            <button
                onClick={() => setTheme('dark')}
                className={[
                    'px-3 py-1.5 rounded-md text-xs font-medium transition-all',
                    theme === 'dark'
                        ? 'bg-white shadow text-slate-900'
                        : 'text-slate-600 hover:text-slate-900'
                ].join(' ')}
                title={t('theme.dark.title')}
            >
                🌙 {t('theme.dark.label')}
            </button>
        </div>
    );
}

export type { Theme };
